import React from "react";

export default function VideoThumbnail({
  video,
  index,
  isActive,
  isLoading,
  onClick,
  onKeyDown,
  width,
  height,
  className = "",
  isMobile = false,
  thumbnailRef,
}) {
  const baseClasses = `relative cursor-pointer transition-all duration-300 flex-shrink-0 ${
    isActive
      ? `opacity-100 shadow-[0px_0px_14.8px_0px_#c5bbff]`
      : isMobile
        ? "opacity-50"
        : "opacity-20 hover:opacity-40"
  }`;

  const containerClasses = `${baseClasses} ${className}`;

  return (
    <div
      ref={thumbnailRef}
      data-index={index}
      className={containerClasses}
      style={width ? { width: `${width}px` } : {}}
      onClick={() => onClick(index)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(index);
        }
        if (onKeyDown) onKeyDown(e);
      }}
      tabIndex={0}
      role="tab"
      aria-selected={isActive}
      aria-label={`Video ${index + 1}: ${video.thumbnail_title?.text || "Untitled"}`}
    >
      <div
        className={`w-full rounded-md overflow-hidden bg-white`}
        style={{ height: `${height}px` }}
      >
        {isLoading ? (
          <div className="w-full h-full bg-gray-300 animate-pulse" />
        ) : (
          <img
            src={video.thumbnail?.url}
            alt={video.thumbnail?.alt || `Video ${index + 1} thumbnail`}
            className="w-full h-full object-cover"
            loading={index <= (isMobile ? 1 : 2) ? "eager" : "lazy"}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        )}
        {/* Fallback for broken images */}
        <div
          className={`w-full h-full bg-gray-600 flex items-center justify-center text-white ${isMobile ? "text-xs" : "text-sm"} hidden`}
        >
          Image unavailable
        </div>
      </div>
    </div>
  );
}
